import { axios } from "../../lib/axios";

export const DeleteBlog = (blogId: string) => {
    return axios.delete(`/blog/${blogId}`)
        .then(response => response.data);
};